<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div class="col-sm-3 p-0" v-if="question.showDate">
      <input type="text" class="input-text readonly weight_input" placeholder v-model="question.dateFormat" readonly />
    </div>
    <div class="col-sm-3 p-0" v-if="question.showTime" :class="{ 'pl-10': question.showDate }">
      <span v-if="question.timeFormat == '12'">
        <input type="text" class="input-text readonly weight_input time_small_div" placeholder value="--:-- AM" readonly />
      </span>
      <span v-if="question.timeFormat == '24'">
        <input type="text" class="input-text readonly weight_input time_small_div" placeholder value="--:--" readonly />
      </span>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div class="col-lg-12 pl-0 mt-10 pr-0" v-else-if="mode == 'EDIT'">
    <div class="p-0 pt-10 pb-10 clearfix">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text add-help-in-date-time-position"
          :class="{
            'right-position': activityDetails.customParticipantMessaging
          }"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
        <span
          class="add-help-text"
          :style="{
            color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Message
        </span>
      </div>
      <quill-editor class="bg-white mt-18" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>

    <div class="col-lg-8 pl-0 start-date" v-if="question.showDateRange && question.dateRange == 0">
      <div class="col-lg-3 pl-0">
        <h5 class="operator_text">Start date</h5>
        <datepicker :use-utc="true" input-class="datepicker-class form-control inner-card-value" :placeholder="question.dateFormat" v-model="question.startDate" :format="question.dateFormat.replace('mm', 'MM')" :disabled="question.useStartCurrentDate" :class="{ disabled_datepicker: question.useStartCurrentDate }" name="startDate"></datepicker>
      </div>
      <div class="col-lg-3 pl-0 pt-35">
        <label>
          <input type="checkbox" v-model="question.useStartCurrentDate" v-on:click="setStartCurrentDate($event)" />
          <span>Use current date</span>
        </label>
      </div>
      <div class="col-lg-3">
        <h5 class="operator_text">End date</h5>
        <datepicker :use-utc="true" input-class="datepicker-class form-control inner-card-value" :placeholder="question.dateFormat" v-model="question.endDate" name="endDate" :format="question.dateFormat.replace('mm', 'MM')" :disabled="question.useEndCurrentDate" :class="{ disabled_datepicker: question.useEndCurrentDate }"></datepicker>
      </div>
      <div class="col-lg-3 pl-0 pt-35">
        <label>
          <input type="checkbox" v-model="question.useEndCurrentDate" v-on:click="setEndCurrentDate($event)" />
          <span>Use current date</span>
        </label>
      </div>
    </div>
    <div class="col-lg-8 pl-0 start-date" v-if="question.showDateRange && question.dateRange == 1">
      <div class="col-lg-3 pl-0">
        <h5 class="operator_text">Target date</h5>
        <datepicker :use-utc="true" input-class="datepicker-class form-control inner-card-value" :placeholder="question.dateFormat" v-model="question.targetDate" name="targetDate" :format="question.dateFormat.replace('mm', 'MM')" :disabled="question.useTargetCurrentDate" :class="{ disabled_datepicker: question.useTargetCurrentDate }"></datepicker>
      </div>
      <div class="col-lg-3 pl-0 pt-35">
        <label>
          <input type="checkbox" v-model="question.useTargetCurrentDate" v-on:click="setTargetCurrentDate($event)" />
          <span>Use current date</span>
        </label>
      </div>
      <div class="col-lg-3 pl-0">
        <h5 class="operator_text">Days before</h5>
        <input type="number" pattern="[0-9]+" class="form-control form-control-sm input-style" v-model="question.daysBefore" placeholder="Days" min="0" max="2048" />
      </div>
      <div class="col-lg-3 pl-0">
        <h5 class="operator_text">Days after</h5>
        <input type="number" pattern="[0-9]+" class="form-control form-control-sm input-style" v-model="question.daysAfter" placeholder="Days" min="0" max="2048" />
      </div>
    </div>

    <div class="col-lg-8 pl-0 mt-10 start-date" v-if="question.showTimeRange && question.timeRange == 0">
      <div class="col-lg-3 pl-0">
        <h5 class="operator_text">Start time</h5>
        <vue-timepicker v-model="question.startTime" hide-clear-button :format="question.timeFormat == '12' ? 'hh:mm A' : 'HH:mm'"></vue-timepicker>
      </div>
      <div class="col-lg-3">
        <h5 class="operator_text">End time</h5>
        <vue-timepicker v-model="question.endTime" hide-clear-button :format="question.timeFormat == '12' ? 'hh:mm A' : 'HH:mm'"></vue-timepicker>
      </div>
    </div>
    <div class="col-lg-8 pl-0 mt-10 start-date" v-if="question.showTimeRange && question.timeRange == 1">
      <div class="col-lg-3 pl-0">
        <h5 class="operator_text">Hours before</h5>
        <input type="number" class="form-control form-control-sm input-style" v-model="question.hoursBefore" placeholder="hours" min="0" max="2048" />
      </div>
      <div class="col-lg-3 pl-0">
        <h5 class="operator_text">Hours after</h5>
        <input type="number" class="form-control form-control-sm input-style" v-model="question.hoursAfter" placeholder="hours" min="0" max="2048" />
      </div>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepDateTime",

  mixins: [activityStepCustomMessage],

  data() {
    return {
      isAddHelpEnabled: false,
      timeObj: {
        HH: "",
        hh: "",
        mm: "",
        A: ""
      }
    };
  },
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    Datepicker,
    VueTimepicker,
    quillEditor
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    setStartCurrentDate() {
      this.question.startDate = null;
    },
    setEndCurrentDate() {
      this.question.endDate = null;
    },
    setTargetCurrentDate() {
      this.question.targetDate = null;
    },
    setDateSelection(event) {
      if (event.target.checked && event.target.checked == true) {
        if (!this.question.dateFormat) {
          this.question.dateFormat = "mm/dd/yyyy";
        }
      }
    },
    setTimeRangeSelection(event) {
      this.$nextTick(() => {
        if (event.target.checked && event.target.checked == true) {
          this.question.timeRange = 0;
        } else {
          this.question.timeRange = 1;
          if (!this.question.startTime) {
            this.question.startTime = "";
          }
          if (!this.question.endTime) {
            this.question.endTime = "";
          }
        }
      });
    },
    setDateRangeSelection(event) {
      this.$nextTick(() => {
        if (event.target.checked && event.target.checked == true) {
          this.question.dateRange = 0;
        } else {
          this.question.dateRange = 1;
        }
      });
    },

    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },

    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (!question.showDate && !question.showTime) {
        errorObj.isValid = false;
        errorObj.msg = "Please select answer type.";
        return errorObj;
      }

      if (question.showDateRange && question.dateRange == 0) {
        if (!question.hasOwnProperty("useStartCurrentDate")) {
          question.useStartCurrentDate = false;
        }
        if (!question.hasOwnProperty("useEndCurrentDate")) {
          question.useEndCurrentDate = false;
        }
        if (question.useStartCurrentDate == false && !question.startDate) {
          errorObj.isValid = false;
          errorObj.msg = "Start date is required.";
          return errorObj;
        }
        if (question.useEndCurrentDate == false && !question.endDate) {
          errorObj.isValid = false;
          errorObj.msg = "End date is required.";
          return errorObj;
        }

        const startDate = question.useStartCurrentDate ? moment().format("YYYY-MM-DD") : moment(question.startDate).format("YYYY-MM-DD");
        const endDate = question.useEndCurrentDate ? moment().format("YYYY-MM-DD") : moment(question.endDate).format("YYYY-MM-DD");
        const startDateMoment = moment(startDate);
        const endDateMoment = moment(endDate);
        const diffDay = endDateMoment.diff(startDateMoment, "days");
        if (diffDay < 0) {
          errorObj.isValid = false;
          errorObj.msg = "End date must be the same or later than the start date.";
          return errorObj;
        }
      }
      if (question.showDateRange && question.dateRange == 1) {
        if (!question.hasOwnProperty("useTargetCurrentDate")) {
          question.useTargetCurrentDate = false;
        }
        if (question.useTargetCurrentDate == false && !question.targetDate) {
          errorObj.isValid = false;
          errorObj.msg = "Target date is required.";
          return errorObj;
        }
        if (question.daysBefore == undefined || question.daysBefore == null || isNaN(parseInt(question.daysBefore))) {
          errorObj.isValid = false;
          errorObj.msg = "Days before is required.";
          return errorObj;
        }
        if (question.daysAfter == undefined || question.daysAfter == null || isNaN(parseInt(question.daysAfter))) {
          errorObj.isValid = false;
          errorObj.msg = "Days after is required.";
          return errorObj;
        }
        const daysBefore = Number(question.daysBefore);
        if (daysBefore < 0) {
          errorObj.isValid = false;
          errorObj.msg = "Zero or greater Days before is required.";
          return errorObj;
        }
        const daysAfter = Number(question.daysAfter);
        if (daysAfter < 0) {
          errorObj.isValid = false;
          errorObj.msg = "Zero or greater Days after is required.";
          return errorObj;
        }
        const regExWholeNumber = "-?[0-9]+?";
        const regExpWholeNumber = new RegExp(`^${regExWholeNumber}$`);
        if (!regExpWholeNumber.test(daysBefore)) {
          errorObj.isValid = false;
          errorObj.msg = "Enter a Days before as a whole number.";
          return errorObj;
        }
        if (!regExpWholeNumber.test(daysAfter)) {
          errorObj.isValid = false;
          errorObj.msg = "Enter a Days after as a whole number.";
          return errorObj;
        }
      }

      if (question.showTimeRange && question.timeRange == 0) {
        if (!question.startTime) {
          errorObj.isValid = false;
          errorObj.msg = "Start time is required.";
          return errorObj;
        }
        if (question.startTime) {
          const startTimeObj = this.getTimeObjectFromTimeString(question.timeFormat, question.startTime);
          const { hh, HH, mm, A } = startTimeObj;
          if (startTimeObj) {
            if (question.timeFormat === "12" && (mm === "mm" || A === "A" || hh === "hh")) {
              errorObj.isValid = false;
              errorObj.msg = "Start time is required.";
              return errorObj;
            } else if (question.timeFormat === "24" && (HH === "HH" || mm === "mm")) {
              errorObj.isValid = false;
              errorObj.msg = "Start time is required.";
              return errorObj;
            }
          }
        }
        if (!question.endTime) {
          errorObj.isValid = false;
          errorObj.msg = "End time is required.";
          return errorObj;
        }
        if (question.endTime) {
          const endTimeObj = this.getTimeObjectFromTimeString(question.timeFormat, question.endTime);
          const { hh, HH, mm, A } = endTimeObj;
          if (endTimeObj) {
            if (question.timeFormat === "12" && (mm === "mm" || A === "A" || hh === "hh")) {
              errorObj.isValid = false;
              errorObj.msg = "End time is required.";
              return errorObj;
            } else if (question.timeFormat === "24" && (HH === "HH" || mm === "mm")) {
              errorObj.isValid = false;
              errorObj.msg = "End time is required.";
              return errorObj;
            }
          }
        }

        const timeFormat = question.timeFormat == "12" ? "hh:mm A" : "HH:mm";
        let startTime;
        let endTime;
        if (question.timeFormat == "12") {
          startTime = question.startTime.hh + ":" + question.startTime.mm + " " + question.startTime.A;
          endTime = question.endTime.hh + ":" + question.endTime.mm + " " + question.endTime.A;
        } else {
          startTime = question.startTime.HH + ":" + question.startTime.mm;
          endTime = question.endTime.HH + ":" + question.endTime.mm;
        }

        const startTimeMoment = moment(startTime, timeFormat);
        const endTimeMoment = moment(endTime, timeFormat);
        if (endTimeMoment.diff(startTimeMoment) < 0) {
          errorObj.isValid = false;
          errorObj.msg = "End Time must be the same or later than the start time.";
          return errorObj;
        }
      }

      if (question.showTimeRange && question.timeRange == 1) {
        if (question.hoursBefore == undefined || question.hoursBefore == null || isNaN(parseInt(question.hoursBefore))) {
          errorObj.isValid = false;
          errorObj.msg = "Hours before is required.";
          return errorObj;
        }
        if (question.hoursAfter == undefined || question.hoursAfter == null || isNaN(parseInt(question.hoursAfter))) {
          errorObj.isValid = false;
          errorObj.msg = "Hours after is required.";
          return errorObj;
        }
        const hoursBefore = Number(question.hoursBefore);
        if (hoursBefore < 0) {
          errorObj.isValid = false;
          errorObj.msg = "Zero or greater Hours before is required.";
          return errorObj;
        }
        const hoursAfter = Number(question.hoursAfter);
        if (hoursAfter < 0) {
          errorObj.isValid = false;
          errorObj.msg = "Zero or greater Hours after is required.";
          return errorObj;
        }
        const regExWholeNumber = "-?[0-9]+?";
        const regExpWholeNumber = new RegExp(`^${regExWholeNumber}$`);
        if (!regExpWholeNumber.test(hoursBefore)) {
          errorObj.isValid = false;
          errorObj.msg = "Enter a Hours before as a whole number.";
          return errorObj;
        }
        if (!regExpWholeNumber.test(hoursAfter)) {
          errorObj.isValid = false;
          errorObj.msg = "Enter a Hours after as a whole number.";
          return errorObj;
        }
      }

      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }

      return {
        isValid: Boolean(question.formattedBody && question.sequence && (question.dateFormat || question.timeFormat) && (question.showDate || question.showTime))
      };
      // break;
    },
    getTimeObjectFromTimeString(timeFormat, time) {
      const timeObj = { ...this.timeObj };
      if (time) {
        if (typeof time === "string") {
          if (timeFormat == "24") {
            const [HH, mm] = time.split(":");
            timeObj.HH = HH;
            timeObj.mm = mm;
          }

          if (timeFormat == "12") {
            const [hh, mmAndA] = time.split(":");
            const [mm, A] = mmAndA.split(" ");
            timeObj.hh = hh;
            timeObj.mm = mm;
            timeObj.A = A;
          }
        }
      }
      return timeObj;
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "showDate", true);
        this.$set(this.question, "showTime", true);
        this.$set(this.question, "showDateRange", false);
        this.$set(this.question, "dateRange", 0);
        this.$set(this.question, "showTimeRange", false);
        this.$set(this.question, "timeRange", 0);
      } else {
        this.$set(this.question, "showDate", this.question.showDate);
        this.$set(this.question, "showTime", this.question.showTime);
        this.$set(this.question, "showDateRange", this.question.showDateRange);
        this.$set(this.question, "dateRange", this.question.dateRange);
        this.$set(this.question, "showTimeRange", this.question.showTimeRange);
        this.$set(this.question, "timeRange", this.question.timeRange);
      }
      if (!this.question.dateFormat) {
        this.$set(this.question, "dateFormat", "mm/dd/yyyy");
      }
      if (!this.question.timeFormat) {
        this.$set(this.question, "timeFormat", "12");
      }
      this.question.isAdvancedScoring = false;
      this.question.score = 0;
    }
  },
  mounted() {
    this.init();
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  }
};
</script>

<style scoped lang="scss">
.start-date input {
  height: 40px;
  border-radius: 3px !important;
  border: solid 2px #d3dfe4 !important;
  font-size: 14px;
}
.col-md-4 .activity-configurator-step-view-mode .readonly.weight_input {
  width: 150%;
  max-width: 150%;
}
.col-md-4 .activity-configurator-step-view-mode .readonly.weight_input.time_small_div {
  position: relative;
  left: 60%;
}
.add-help-text {
  top: -20px;
  &.right-position {
    right: 637px;
  }
}
</style>
